export default {"src":"/_next/static/media/ic-pricetag.ebb504a3.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};